import { AG_GRID_SCROLL_VIEWPORT } from './agGridDomSelectors';

export function getDataGridTooltipId(tableId) {
    return tableId ? `w5-tooltip-${tableId}` : 'w5-tooltip';
}

/**
 * @param {string} [tableId]
 * @returns {HTMLElement | null}
 */
export function getDataGridTooltipElement(tableId) {
    return document.getElementById(getDataGridTooltipId(tableId));
}

function isVisibleReference(element) {
    if (!element) return false;
    const { width, height } = element.getBoundingClientRect();
    return width > 0 && height > 0;
}

/**
 * @param {HTMLElement} baseCell
 * @param {HTMLElement} [gridCell]
 * @returns {HTMLElement}
 */
export function getTooltipReferenceElement(baseCell, gridCell) {
    const candidates = [
        '.w5-toggle-cell__svg-container',
        '.w5-toggle-cell',
        '.w5-cell-favorite__svg-container',
        '.w5-cell-favorite',
    ];

    for (const selector of candidates) {
        const element = baseCell.querySelector(selector);
        if (isVisibleReference(element)) {
            return element;
        }
    }

    if (isVisibleReference(gridCell)) {
        return gridCell;
    }

    return baseCell;
}

/**
 * @param {HTMLElement} [gridCell]
 * @returns {HTMLElement | null}
 */
export function getDataGridScrollViewport(gridCell) {
    return gridCell?.closest(AG_GRID_SCROLL_VIEWPORT) || null;
}
